module.exports = __webpack_public_path__ + "static/media/business-img1.301316da.svg";